export const clearCookie = (name: string, domain?: string) => {
  const domainString = domain ? `; domain=${domain}` : "";
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT${domainString}; path=/`;
};

export const getCookie = (name: string): string => {
  let cookieValue = "";
  if (document.cookie && document.cookie !== "") {
    for (let cookie of document.cookie.split(";")) {
      cookie = cookie.trim();
      if (cookie.substring(0, name.length + 1) === `${name}=`) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
};

export const setCookie = (
  name: string,
  value: string,
  domain?: string,
  days?: number,
) => {
  const domainString = domain ? `; domain=${domain}` : "";
  const expiryString = days
    ? `; expires=${new Date(Date.now() + days * 864e5).toUTCString()}`
    : "";
  document.cookie = `${name}=${encodeURIComponent(
    value,
  )}${domainString}${expiryString}; path=/`;
};
